import React from 'react';
import {Router, Route, IndexRoute, hashHistory} from 'react-router'
import App from '../ui/components/App'
import WorkSessionsPage from '../ui/pages/WorkSessionsPage'
import AssigneesPage from '../ui/pages/AssigneesPage'
import AddItemsPage from '../ui/pages/AddItemsPage'
import CurrentItemsPage from '../ui/pages/CurrentItemsPage'
import OverviewPage from '../ui/pages/OverviewPage'
import StatisticsPage from '../ui/pages/StatisticsPage'
import TestPage  from '../ui/pages/TestPage'
import IndexPage  from '../ui/pages/IndexPage'
import {/*c, checkInitialized,*/ checkHasPermission} from '../ui/components/Require'


const requirePermission = (permission) => (nextState, replace) => {
    if (!checkHasPermission(permission)) {
        console.warn('Lacking permission ' + nextState.location.pathname);
        replace({
            pathname: '/',
            state: { nextPathname: nextState.location.pathname }
        })
    }
}

let routes = (props) => {
    return (
        <Router history={hashHistory}>
            <Route path="/" component={App}>
                {/*<Route path="login" component={LoginPage}/>*/}
                <IndexRoute component={IndexPage}/>
                <Route path="work-sessions" component={WorkSessionsPage} onEnter={requirePermission('pm:work-sessions:list')}/>
                <Route path="assignees" component={AssigneesPage} onEnter={requirePermission('pm:assignees:list')}/>
                <Route path="add-items" component={AddItemsPage} onEnter={requirePermission('pm:add-items:list')}/>
                <Route path="current-items" component={CurrentItemsPage} onEnter={requirePermission('pm:current-items:list')}/>
                <Route path="overview" component={OverviewPage} onEnter={requirePermission('pm:overview:list')}/>
                <Route path="statistics" component={StatisticsPage} onEnter={requirePermission('pm:statistics:list')}/>
                <Route path="test" component={TestPage}/>
            </Route>
        </Router>
    )
}

export default routes;


// WEBPACK FOOTER //
// ./src/routes/index.js